import { useEffect, useState } from "react";
import { useDialogs } from "./DialogsContext";
import { Zap } from "lucide-react";

export default function StickyCTA() {
  const [show, setShow] = useState(false);
  const { openAudit } = useDialogs();

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 800);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!show) return null;

  return (
    <div
      data-testid="sticky-cta-bar"
      className="fixed bottom-6 left-1/2 -translate-x-1/2 z-30 hidden md:flex items-center gap-4 bg-[#0a0a0a] border border-[#ccff00]/40 pl-5 pr-2 py-2 shadow-[0_0_40px_-10px_rgba(204,255,0,0.4)]"
    >
      <Zap className="w-4 h-4 text-[#ccff00]" fill="#ccff00" />
      <span className="text-sm font-semibold">
        Free audit. Zero risk. Real revenue.
      </span>
      <button
        data-testid="sticky-cta-audit"
        onClick={openAudit}
        className="h-10 px-5 bg-[#ccff00] text-black text-xs font-bold uppercase tracking-wider hover:bg-[#b3e600] transition-colors"
      >
        Get mine
      </button>
    </div>
  );
}
